import React, { useState } from 'react';
import { Select } from 'antd';

const EducationInfo = ({ educationData, languageData, computerSkillsData }) => {
    const maxRows = Math.max(languageData.length, computerSkillsData.length);
    const formatDate = (date) => {
        const rawDate = date.split('T')[0];
        const dateParts = rawDate.split('-');
        return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
    }
    return (
        <div>
            <table style={{ marginTop: '-1px' }}>
                <tbody>
                    <tr>
                        <th colSpan="4" className="bg">
                            <p className="center" style={{ fontSize: '16px' }}>Образование</p>
                        </th>
                    </tr>
                    <tr>
                        <th width="25%"><p className="center">Период и вид обучения</p></th>
                        <th width="25%"><p className="center">Название ВУЗа (ССУ)</p></th>
                        <th width="30%"><p className="center">Факультет, специальность</p></th>
                        <th width="20%"><p className="center">Диплом</p></th>
                    </tr>
                    {educationData.map((edu, index) => (
                        <tr key={ "edu" + index.toString()}>
                            <td>
                                <p>С {formatDate(edu.Start)} по {formatDate(edu.End)}<br /> {edu.EducationKind.Name}</p>
                            </td>
                            <td><p>{edu.Institution.Name}</p></td>
                            <td><p>{edu.Faculty}<br />{edu.Speciality.Name}</p>
                            </td>
                            <td style={{position: "relative"}} ><p>{edu.EducationType.Name}<br />{edu.DocTypeEducation.Name}<br />{edu.DocSeries}{edu.DocNumber} от {formatDate(edu.DocDateIssued)}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>            
            {/* <table style={{ marginTop: '-1px' }}>
                <tbody>
                    <tr>
                        <th colSpan="2" className="bg">
                        <p className="center" style={{ fontSize: '16px' }}>ЗНАНИЕ ЯЗЫКОВ</p>
                        </th>
                    </tr>
                    <tr>
                        <th width="30%"><p className="center">Языки</p></th>
                        <th width="70%"><p className="center">Уровень владения<br />(нет/удовлетворительно/хорошо/отлично)</p></th>
                    </tr>
                    {languageData.map((lang, index) => (
                    <tr key={"lang" + index.toString()}>
                        <td><p>{lang.Language.Name}</p></td>
                        <td><p>{lang.LanguageDegree.Name}</p></td>
                    </tr>))}
                </tbody>
            </table>
            <table style={{ marginTop: '-1px' }}>
                <tbody>
                    <tr>
                        <th colSpan="2" className="bg">
                            <p className="center" style={{ fontSize: '16px' }}>КОМПЬЮТЕРНАЯ ГРАМОТНОСТЬ</p>
                        </th>
                    </tr>
                    <tr>
                        <th width="50%"><p className="center">Какими программами владеете:</p></th>
                        <th width="50%"><p className="center">Уровень владения<br/>(Не владеет/Пользователь/Опытный пользователь/Программист)</p></th>
                    </tr>
                    {computerSkillsData.map((skill, index) => (
                        <tr key={"skill" + index.toString()}>
                            <td><p>{skill.Software.Name}</p></td>
                            <td><p>{skill.SoftwareLevel.Name}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table> */}
            <table style={{ marginTop: '-1px' }}>
                <tbody>
                    <tr>
                        <th colSpan="2" className="bg">
                        <p className="center" style={{ fontSize: '16px' }}>ЗНАНИЕ ЯЗЫКОВ</p>
                        </th>
                        <th colSpan="2" className="bg">
                        <p className="center" style={{ fontSize: '16px' }}>КОМПЬЮТЕРНАЯ ГРАМОТНОСТЬ</p>
                        </th>
                    </tr>
                    <tr>
                        <th width="15%"><p className="center">Языки</p></th>
                        <th width="35%"><p className="center">Уровень владения<br />(нет/удовлетворительно/хорошо/отлично)</p></th>
                        <th width="25%"><p className="center">Какими программами владеете:</p></th>
                        <th width="25%"><p className="center">Уровень владения<br/>(Не владеет/Пользователь/Опытный пользователь/Программист)</p></th>
                    </tr>
                    {[...Array(maxRows)].map((_, index) => (
                        <tr key={index}>
                            <td><p>{languageData[index]?.Language?.Name || ''}</p></td>
                            <td><p>{languageData[index]?.LanguageDegree?.Name || ''}</p></td>
                            <td><p>{computerSkillsData[index]?.Software?.Name || ''}</p></td>
                            <td><p>{computerSkillsData[index]?.SoftwareLevel?.Name || ''}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default EducationInfo;
